import * as Schema from "effect/Schema";

// MW3B (register GOALS/GOALS-MEDIA-WORKFLOWS.html#mw3b), revised 18 September
// 2026 to the current Canvas doors: an explicitly selected retained local take
// is shared into a chosen World as a Canvas revision. The Desk stages and
// registers the take's bytes through the World's verifying asset doors and
// creates the Canvas (canvasId null) or saves the next revision of an existing
// one (canvasId with the head sequence last read) through neucleos_canvas. One
// request key per intended share; retries answer the same result. Copy into a
// World is not publication.
const Key = Schema.String.check(Schema.isMinLength(1), Schema.isMaxLength(256));
const Digest = Schema.String.check(Schema.isPattern(/^[0-9a-f]{64}$/));
const CanvasId = Schema.String.check(Schema.isPattern(/^cnv_[0-9a-f]{24}$/));
export const MediaSharingRequest = Schema.Union([
  Schema.Struct({
    action: Schema.Literal("assets.share"),
    params: Schema.Struct({
      requestKey: Key,
      worldKey: Key,
      title: Key,
      canvasId: Schema.NullOr(CanvasId),
      expectedHeadSequence: Schema.NullOr(Schema.Int.check(Schema.isGreaterThan(0))),
      source: Schema.Struct({ assetId: Key, sha256: Digest }),
      audience: Schema.Literal("world-members"),
    }),
  }),
]);
export type MediaSharingRequest = typeof MediaSharingRequest.Type;
export interface MediaShareReceipt {
  readonly canvasId: string;
  readonly memberId: string;
  readonly revisionId: string;
  readonly sequence: number;
  readonly sha256: string;
  readonly path: string;
}
